export type APISuperAdminTenantResponseType = Partial<{
  id: number;
  name: string;
  domain: string;
  registration_completed: boolean;
}>;

export interface IAPISuperAdminTenant {
  getData(): APISuperAdminTenantResponseType;
  isDataValid(): boolean;
}

export class APISuperAdminTenant implements IAPISuperAdminTenant {
  readonly data: APISuperAdminTenantResponseType;

  constructor(data: APISuperAdminTenantResponseType) {
    this.data = data;
  }

  getData(): APISuperAdminTenantResponseType {
    return this.data;
  }

  isDataValid(): boolean {
    return !!this.data.id && !!this.data.name;
  }
}
